import React from 'react'
import './style.scss'

interface Props<T> {
  label: T
  style?: Object
  animationStyle?: Object
  theme?: 'transparent' | 'white-box'
  imageUrl?: string
}

const Loader = function <T>(props: Props<T>) {

  let classes = 'c-loader-wrapper'

  if (props.theme) {
    classes += ' s-' + props.theme
  }



  return (
    <div
      className={classes}
    >
      {props.imageUrl ?
        <div className="c-loader__with-image" style={{ backgroundImage: `url(${window.origin + props.imageUrl})` }}>
        </div>
        : <div>
          <div style={props.animationStyle ? { width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '1em', ...props.animationStyle } : { width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '1em' }}>
            <div className="ring-animation">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="c-main-content__loader_label" style={{ padding: 0, color: 'black' }}>
            {props.label}
          </div>
        </div>}
    </div>
  )
}

export default Loader